import { render } from "./customer-service.vue?vue&type=template&id=850c388a&scoped=true"
import script from "./customer-service.vue?vue&type=script&lang=js"
export * from "./customer-service.vue?vue&type=script&lang=js"

import "./customer-service.vue?vue&type=style&index=0&id=850c388a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-850c388a"]])

export default __exports__